import { axios } from "services";

export const loginUser = async ({ email, password }) => {
  const response = await axios.post("/admin/login", { email, password });
  return response.data;
};

